import { render, staticRenderFns } from "./LastNews.vue?vue&type=template&id=6ab900c2&scoped=true&"
import script from "./LastNews.vue?vue&type=script&lang=js&"
export * from "./LastNews.vue?vue&type=script&lang=js&"
import style0 from "./LastNews.vue?vue&type=style&index=0&id=6ab900c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab900c2",
  null
  
)

export default component.exports